import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';

const Wrapper = styled.nav`
  color: var(--vg-colors-gray-600);
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 0 6px rgb(0 0 0 / 18%);
  position: relative;
`;

export const NavWrapper = ({
  navbarHeight,
  children,
  ...props
}: {
  navbarHeight: number;
  children: React.ReactNode;
  props?: HTMLAttributes<HTMLElement>;
}) => {
  return (
    <Wrapper style={{ height: `${navbarHeight}px` }} {...props}>
      {children}
    </Wrapper>
  );
};
